import React, { FunctionComponent, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { Market } from "../../models/Market";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { thunkFetchMarkets } from "../../store/markets/actions";
import { getFlags } from "../../utils";
import { asList } from "../../hooks/useLoadIfEmpty";

interface MarketSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: Market) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
}

export const MarketSelect: FunctionComponent<MarketSelectProps> = ({
  label = "Market",
  onSelected,
  onChange,
  variant = "standard",
  value = [],
  error = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const markets = asList<Market>(
    useSelector<AppState, unknown>(s => s.markets)
  );
  const [state, setState] = useState<ReadonlyArray<Market>>([]);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let market = state.find(market => market.id === event.target.value);

      if (market) {
        onSelected(market);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    // load if not loaded
    if (!markets || !markets.length) {
      dispatch(thunkFetchMarkets());
    }
  }, []);

  useEffect(() => {
    return setState([...markets].sort((a, b) => (a.name > b.name ? 1 : -1)));
  }, [markets]);

  return (
    <FormControl variant={variant} className={props.className} error={error}>
      <InputLabel
        id="cluster-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="market-select-label"
        id="market-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(market => (
            <MenuItem key={market.id} value={market.id}>
              {market.name} {getFlags(market.countryCode)}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
